<template>
  <v-container>
    <h1 class="text-center">{{ $t('title.subjects')}}</h1>

    <v-card v-for="cardset in cardsets.list"
            :key="cardset.id"
            max-width="300"
            >
      <v-card-title>{{ cardset.name }}</v-card-title>
      <v-card-text v-html="toHtml(cardset.description, cardset.lang)"></v-card-text>
      <v-card-actions>
        <v-btn
                class="text-center"
                @click="goStudy(cardset.id)"
                :color="yellow"
                style="margin-right: auto; margin-left: auto;"
        >
          {{ $t('nav.study') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import basic from "./mixins/basic";
import {CardsetList} from "../models/Cardset";

export default {
  name: 'Home',
  mixins: [basic],
  data () {
    return {
      cardsets: new CardsetList(),
      listProperty: 'cardsets',
    }
  },
  methods: {
    goStudy (id) {
      this.$router.push({ name: 'cardset-detail', params: { pk: id } })
    },
  },
  computed: {
  },
  mounted () {
    // let that = this;
    this.cardsets.api.fetch();
    /*
    .catch(function (error) {
      // eslint-disable-next-line no-console
      // console.log('Error:', error, error.response);
      if (error.response.data.code === 'token_not_valid') {
        // eslint-disable-next-line no-console
        console.log('Token invalid');
        // that.$router.push({ name: 'logout' });
        // that.logoutUser();
        // if (!that.loggedIn()) {
        //   that.$route.push({ name: 'home' });
        // }
      }
    });
     */
  }
}
</script>

<style scoped>

</style>
